import { Link, useLocation } from 'react-router-dom';
import { normalizeLanguageCode } from '../utils/language';

const CustomLink = ({ to, className, onClick, style, children }) => {
  const location = useLocation();
  const currentParams = new URLSearchParams(location.search);
  const lang = normalizeLanguageCode(localStorage.getItem('lang') || currentParams.get('lang'));

  const [basePath, toQueryString] = (to || '').split('?');
  const newParams = new URLSearchParams(toQueryString || '');

  for (const [key, value] of currentParams.entries()) {
    if (!newParams.has(key)) {
      newParams.set(key, value);
    }
  }

  newParams.set('lang', lang);

  const finalUrl = `${basePath}?${newParams.toString()}`;

  return (
    <Link to={finalUrl} className={className} onClick={onClick} style={style}>
      {children}
    </Link>
  );
};

export default CustomLink;
